import { FC, useEffect, useState } from 'react';
import Link from 'next/link';
import { ActiveLine, ContentContainer, ContentWrapper } from './ActivitySubmenu.style';
interface Props {
  activePath: string;
  setIsOpen: (val: boolean) => void;
}
const ActivitySubmenuContent: FC<Props> = ({
  setIsOpen,
  activePath
}: Props) => {
  const handleScroll = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <ContentContainer onMouseLeave={() => setIsOpen(false)}>
            <Link href="/promotion" onClick={() => setIsOpen(false)}>
                <ActiveLine $isActive={activePath === 'promotion'} />
                <ContentWrapper>โปรโมชัน</ContentWrapper>
            </Link>
            <Link href="/news" onClick={() => setIsOpen(false)}>
                <ActiveLine $isActive={activePath === 'news'} />
                <ContentWrapper>ข่าวสาร</ContentWrapper>
            </Link>
        </ContentContainer>;
};
export default ActivitySubmenuContent;